<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 text-center>
        <div class="mt-12 pt-10">
          <img :src="images.success" height="245px">
        </div>
        <h3 class="secondary--text mt-6">
          <v-icon class="secondary--text mr-1">mdi-check</v-icon>
          <div>{{ $t('a') }}</div>
        </h3>
        <div class="mt-2 mb-12"><b>{{ $t('b') }}</b></div>
        <div class="mt-12"><small>{{ $t('c') }}</small></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>


export default {
  data: () => ({
    images: {
      success: require('@/assets/app/images/Files_And_Folder_Flatline.svg'),
    },
  }),
}
</script>


<i18n>
{
  "fr": {
    "a": "Retrouvez la nouvelle version du dossier dans votre SIRH.",
    "b": "Votre dossier a été mis à jour avec succès.",
    "c": "Vous pouvez fermer cette page."
  },
  "en": {
    "a": "You can find the new version of the CV in your HRIS.",
    "b": "Your CV has successfully been updated.",
    "c": "You can now close this page."
  }
}
</i18n>
